import { AppEventPublisher } from "src/AppEventPublisher";
import { useSudowriteStore } from "src/stores/sudowriteStore";

type OpenOptions = {
  advanced: boolean;
  source: "memory_preserved_thinking_link" | "language_preference_toast" | "conversation_starter";
};

/**
 * Open Chat Personalization inside More Settings.
 * Prefer calling from UI affordances (e.g. "Memory preserved" in thinking steps).
 */
export function openChatPreferences(opts: OpenOptions) {
  AppEventPublisher.agenticChat.chatPersonalizationOpened(opts.source);
  useSudowriteStore.getState().openStyleSettings("chat-personalization", {
    advanced: opts.advanced,
  });
}
